"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NO_DIRECTION = exports.DESC = exports.ASC = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _Theme = _interopRequireDefault(require("../../themes/Theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ASC = "ASC";
exports.ASC = ASC;
var DESC = "DESC";
exports.DESC = DESC;
var NO_DIRECTION = "NONE";
exports.NO_DIRECTION = NO_DIRECTION;

var SortIcon = function SortIcon(_ref) {
  var direction = _ref.direction;
  var styles = {
    color: _Theme["default"]["mlb-red"],
    hoverColor: _Theme["default"]["mlb-red"],
    size: "1rem"
  };
  return direction === DESC ? _react["default"].createElement(_Icon["default"], {
    style: {
      lineHeight: "24px"
    },
    className: "ml-2",
    iconName: "fa-caret-down",
    styles: styles
  }) : _react["default"].createElement(_Icon["default"], {
    className: "ml-2",
    iconName: "fa-caret-up",
    styles: styles
  });
};

SortIcon.propTypes = {
  direction: _propTypes["default"].string.isRequired
};
var _default = SortIcon;
exports["default"] = _default;